import { defaultStore } from '../../../translations';
import { timeZones } from '../../../constants/shared/time/timeZones';
import { isBoolean, isString } from 'lodash';

/**
 * Хук возвращает функцию, которая проверяет, не наступила ли еще указанная дата,
 * если время для всех часовых поясов одинаковое, то указать дату нужно в поле "forAll".
 * @returns {function(string): boolean} Функция, принимающая дату в формате "1990-10-25T23:59"
 * и возвращающая true, если текущее время меньше переданной даты с учетом часового пояса.
 */

export default function useGetIsTruthTime() {
  return (dates) => {
    const date = dates.forAll ?? dates[defaultStore];
    if (isBoolean(date)) return date;
    if (!isString(date)) return true;
    const timeZone = timeZones[defaultStore];
    return Date.now() < new Date(`${date}:${timeZone}`).getTime();
  };
}
